/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionAccount } from './TransactionAccount';
import {
    TransactionAccountFromJSON,
    TransactionAccountFromJSONTyped,
    TransactionAccountToJSON,
} from './TransactionAccount';

/**
 * 
 * @export
 * @interface TransactionsTransactionAccount
 */
export interface TransactionsTransactionAccount {
    /**
     * 
     * @type {Array<TransactionAccount>}
     * @memberof TransactionsTransactionAccount
     */
    value?: Array<TransactionAccount>;
}

/**
 * Check if a given object implements the TransactionsTransactionAccount interface.
 */
export function instanceOfTransactionsTransactionAccount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransactionsTransactionAccountFromJSON(json: any): TransactionsTransactionAccount {
    return TransactionsTransactionAccountFromJSONTyped(json, false);
}

export function TransactionsTransactionAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsTransactionAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : ((json['value'] as Array<any>).map(TransactionAccountFromJSON)),
    };
}

export function TransactionsTransactionAccountToJSON(value?: TransactionsTransactionAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value === undefined ? undefined : ((value.value as Array<any>).map(TransactionAccountToJSON)),
    };
}

